import { render, staticRenderFns } from "./CustomerLogin.vue?vue&type=template&id=91040f3a&"
import script from "./CustomerLogin.vue?vue&type=script&lang=js&"
export * from "./CustomerLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports